<template>
  <v-content>
    <v-container
      fill-height
      fluid>
      <v-layout
        align-center
        justify-center>
        <v-flex
          xs12
          sm8
          md4>
          <v-card
            style="color: rgb(75, 85, 99); padding: 20px"
            class="elevation-12">

            <div style="width: 100px; margin: 0 auto;">
              <v-img src="/img/logo.png"/>
            </div>
            <br>
            <v-card-text>
              <v-form v-model="valid">
                <v-text-field
                  ref="email"
                  v-model="email"
                  :rules="[rules.required, rules.email]"
                  prepend-icon="mdi-account"
                  label="Email"
                  placeholder="Email"
                  required
                  disabled
                />
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      ref="firstname"
                      v-model="firstname"
                      :rules="[rules.required, rules.max25chars]"
                      prepend-icon="mdi-account"
                      label="First Name"
                      placeholder="First Name"
                      required
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      ref="lastname"
                      v-model="lastname"
                      :rules="[rules.required, rules.max25chars]"
                      prepend-icon="mdi-account"
                      label="Last Name"
                      placeholder="Last Name"
                      required
                    />
                  </v-flex>
                </v-layout>

                <v-text-field
                  ref="address"
                  v-model="address"
                  :rules="[rules.required, rules.max125chars]"
                  prepend-icon="mdi-account"
                  label="Address"
                  placeholder="Address"
                  required
                />
                <v-text-field
                  ref="password"
                  v-model="password"
                  :rules="[rules.required]"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showPassword ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  label="Password"
                  placeholder="*********"
                  counter
                  required
                  @keydown.enter="login"
                  @click:append="showPassword = !showPassword"
                />
                <v-text-field
                  ref="password_confirmation"
                  v-model="password_confirmation"
                  :rules="[rules.required, passwordConfirmationRule]"
                  :append-icon="showPasswordConfirmation ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showPasswordConfirmation ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  label="Password"
                  placeholder="*********"
                  counter
                  required
                  @keydown.enter="login"
                  @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                />
              </v-form>
            </v-card-text>
            <v-divider class="mt-5"/>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                align-center
                justify-center
                color="general"
                @click="join">Join
              </v-btn>
            </v-card-actions>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </v-card>
        </v-flex>
      </v-layout>

    </v-container>
  </v-content>
</template>

<script>
  import axios from 'axios'

  export default {
    data: function () {
      return {
        firstname: '',
        lastname: '',
        address: '',
        email: this.$route.query.email,
        password: '',
        password_confirmation: '',
        snack: false,
        snackColor: '',
        snackText: '',
        snackbar: false,
        showPassword: false,
        showPasswordConfirmation: false,
        valid: false,
        rules: {
          required: value => !!value || 'Required.',
          max25chars: v => v.length <= 25 || 'Input too long!',
          max125chars: v => v.length <= 125 || 'Input too long!',
          // counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
        }
      }
    },
    computed: {
      passwordConfirmationRule () {
        return () => (this.password === this.password_confirmation) || 'Password must match'
      }
    },
    // Sends action to Vuex that will log you in and redirect to the dash otherwise, error
    methods: {
      join: function () {
        if (this.valid) {
          let firstname = this.firstname
          let lastname = this.lastname
          let address = this.address
          let email = this.email
          let password = this.password
          let password_confirmation = this.password_confirmation
          this.$store.state.spinning = true

          axios.post('/api/join', {
            'firstname': firstname,
            'lastname': lastname,
            'address': address,
            'email': email,
            'password': password,
            'password_confirmation': password_confirmation,
            'code': this.$route.params.code
          })
                  .then(response => {
                    let status = response.data.status
                    this.snack = true
                    this.snackColor = 'success'
                    this.$store.state.spinning = false

                    if (status === 'Joined') {
                      this.snackText = 'You already have an account with us!'
                    } else if (status === 'Not Invited') {
                      this.snackText = 'Contact info@blahblahblahapp.io to be invited!'
                    } else if (status === 'Created') {
                      this.snackText = 'Affiliate account created, please fill your payment information first!'
                      setTimeout(() => {
                        // this.$router.push('/')
                        this.$store.dispatch('login', {
                          username: email,
                          password: password,
                          remember: false
                        })
                                .then(() => this.$router.push('/dashboard/affiliate-profile'))
                                .catch(err => {
                                          console.log(err)
                                        }
                                )
                      }, 2000)
                    }
                  })
                  .catch(err => {
                    this.showError(err.response.data.errors)
                    console.log(err.response.data.errors)
                    this.$store.state.spinning = false
                          }
                  )
        }
      },
      showError (errorMessage) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = errorMessage || 'Something went wrong, try again later!'
      }
    },
    metaInfo () {
      return {
        title: 'Blah Blah Blah Invite'
      }
    }
  }
</script>
